import React, {useContext, useEffect, useState} from 'react';

import {makeStyles} from "@material-ui/core/styles";

import Button from "@material-ui/core/Button";
import {useHistory} from "react-router-dom";
import {PermissionsContext, ErrorContext} from "../utils/constants";
import Colors from "../utils/colors";
import {getData} from "../utils/apiUtils";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import apiFetch from "../utils/apiUtils";
import Chip from "@material-ui/core/Chip";

const useStyles = makeStyles(() => ({
  h1: {
    fontWeight: 500,
    fontSize: '56px',
    lineHeight: '66px',
  },
  addContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%'
  },
  addArea: {
    width: '45%',
    backgroundColor: Colors.lightBlue,
    padding: '1rem'
  },
  inputStyle: {
    marginTop: '1rem',
    marginBottom: '1rem',
    backgroundColor: 'white'
  },
  tableStyle: {
    border: '1px solid black',
    padding: '1rem'
  },
  table: {
    border: '1px solid black',
    width: '100%',
    marginTop: '3rem'
  },
  chip: {
    margin: '0.5rem'
  }
}));

const types = [
  { value: 1, label: 'SOX Review' }, // SOX Review
  { value: 2, label: 'IT Review' }, // IT Review
  { value: 3, label: 'HR Review' }, // HR Review
  { value: 4, label: 'FSSG Review' }, // FSSG Review
  { value: 7, label: 'Operation Services Review' },
  { value: 8, label: 'Shared Services Finance Review' },
  { value: 9, label: 'Organizational Change Management Review' },
  { value: 10, label: 'Scientific Research and Experimental Development (SR&ED) Review' },
  { value: 11, label: 'Supply Chain Management' },
];

export default function AdminReviewerDashboard() {
  const classes = useStyles();
  const history = useHistory();
  const { isAdmin } = useContext(PermissionsContext);
  const { triggerError } = useContext(ErrorContext);

    if (!isAdmin) {
      history.push('/ui/errors/error404');
    }

  const [reviewerList, setReviewerList] = useState([]);
  const [ groupAutocompleteList, setGroupAutocompleteList ] = useState([]);
  const [ selectedGroup, setSelectedGroup ] = useState({displayName: ''});
  const [ currentGroupRole, setCurrentGroupRole ] = useState({value: ''});
  const [ userAutocompleteList, setUserAutocompleteList ] = useState([]);
  const [ selectedUser, setSelectedUser ] = useState({displayName: ''});
  const [ currentUserRole, setCurrentUserRole ] = useState({value: ''});

  useEffect(() => {
    const onError = () => triggerError({
      title: 'Communication Error',
      description: 'We were unable to read your reviewer data from the server. Please try again.',
      onRetry: () => window.location.reload(),
    });

    getData('/users/getreviewers', setReviewerList, onError);
    document.title = 'Rise by TransAlta Admin Reviewers';
  }, [triggerError]);

  const onAutocompleteError = (error) => {
    // deliberately left blank.  We don't want a popup with every letter typed.
    console.log(error);
  };

  const handleGroupAutocompleteChange = (event) => {
    const value = event.target.value;
    if (value.length >=2) {
      getData('/users/groups/' + value, setGroupAutocompleteList, onAutocompleteError);
    }
  };

  const handleUserAutocompleteChange = (event) => {
    const value = event.target.value;
    if (value.length >=2) {
      getData('/users/' + value, setUserAutocompleteList, onAutocompleteError);
    }
  };

  const handleGroupSelect = (event, selectedValue) => {
    if (!selectedValue) {
      return;
    }
    setSelectedGroup(selectedValue);
  };

  const handleUserSelect = (event, selectedValue) => {
    if (!selectedValue) {
      return;
    }
    setSelectedUser(selectedValue);
  };

  const handleGroupRoleChange = (event) => {
    const value = event.target.value;
    const role = types.find(item => item.value === value);
    setCurrentGroupRole(role);
  };

  const handleUserRoleChange = (event) => {
    const value = event.target.value;
    const role = types.find(item => item.value === value);
    setCurrentUserRole(role);
  };


  const handleGroupAdd = () => {
    const data = selectedGroup;
    data.type = currentGroupRole.value;
    apiFetch('/users/reviewergroup', 'POST',
      JSON.stringify(data),
      (results) => {
        setReviewerList(results);
      }, (selectedGroup, currentGroupRole) => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to save group ${selectedGroup.displayName} with role ${currentGroupRole}. Please try again.`,
        onRetry: () => handleGroupAdd(),
      }));
  };

  const handleUserAdd = () => {
    const data = selectedUser;
    data.type = currentUserRole.value;
    apiFetch('/users/revieweruser', 'POST',
      JSON.stringify(data),
      (results) => {
        setReviewerList(results);
      }, (selectedUser, currentUserRole) => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to save user ${selectedUser.displayName} with role ${currentUserRole}. Please try again.`,
        onRetry: () => handleUserAdd(),
      }));
  };

  const handleDelete = (id) => () => {
    apiFetch('/users/reviewer/' + id, 'DELETE',
      null,
      (results) => {
        setReviewerList(results);
      }, () => () => triggerError({
        title: 'Communication Error',
        description: `We were unable to delete the selected card. Please try again.`,
        onRetry: () => handleDelete(id),
      }));
  };

  const getReviewerChip = (reviewer) => {
    if (reviewer.user_id) {
      return  <Chip label={reviewer.name}
                    size="small"
                    onDelete={handleDelete(reviewer.reviewer_id)}
                    color="primary"
                    key={reviewer.reviewer_id + '-tag'}
                    className={classes.chip}
      />;
    } else {
      return  <Chip label={reviewer.ad_group_name + ': ' + reviewer.ad_group_email}
                    size="small"
                    onDelete={handleDelete(reviewer.reviewer_id)}
                    color="primary"
                    key={reviewer.reviewer_id + '-tag'}
                    className={classes.chip}
      />;
    }
  };

  const getReviewerRow = (type) => {
    const reviewers = reviewerList.filter(item => item.mandatory_type === type.value);
    return (
      <tr key={`row-${type.value}`}>
      <td className={classes.tableStyle}>{type.label}</td>
      <td className={classes.tableStyle}>
        {reviewers.map(reviewer => getReviewerChip(reviewer))}
      </td>
      </tr>
    );
  };

  return (
    <main>
      <h1 className={classes.h1}>Reviewer users</h1>
      <div className={classes.addContainer} >
        <div className={classes.addArea}>
          <h2>Add User</h2>
          <TextField
            id={'text-box-role-user'}
            className={classes.inputStyle}
            style={{ width: '100%' }}
            select
            variant="outlined"
            size="small"
            label={'ROLE'}
            onChange={handleUserRoleChange}
            value={currentUserRole.value}
          >
            {types.map((role) => (
              <MenuItem key={role.value} value={role.value}>
                {role.label}
              </MenuItem>
            ))}
          </TextField>
          <Autocomplete
            id={'combo-box-user-1'}
            options={userAutocompleteList}
            getOptionLabel={option => option? option.displayName : ''}
            style={{ width: '100%' }}
            value={selectedUser}
            size="small"
            onChange={handleUserSelect}
            renderInput={params => (
              <TextField {...params}
                         variant="outlined"
                         fullWidth
                         className={classes.inputStyle}
                         onChange={handleUserAutocompleteChange}
                         placeholder="User Name..."
              />
            )}
          />
          <div className={classes.addContainer} >
            <Button
              className={classes.btnStyle}
              variant="contained"
              onClick={handleUserAdd}
            >
              ADD
            </Button>
          </div>
        </div>
        <div className={classes.addArea}>
          <h2>Add Group</h2>
          <TextField
            id={'text-box-role-group'}
            className={classes.inputStyle}
            style={{ width: '100%' }}
            select
            variant="outlined"
            size="small"
            label={'ROLE'}
            onChange={handleGroupRoleChange}
            value={currentGroupRole.value}
          >
            {types.map((role) => (
              <MenuItem key={role.value} value={role.value}>
                {role.label}
              </MenuItem>
            ))}
          </TextField>
          <Autocomplete
            id={'combo-box-group-1'}
            options={groupAutocompleteList}
            getOptionLabel={option => option? option.displayName : ''}
            style={{ width: '100%' }}
            value={selectedGroup}
            size="small"
            onChange={handleGroupSelect}
            renderInput={params => (
              <TextField {...params}
                         variant="outlined"
                         fullWidth
                         className={classes.inputStyle}
                         onChange={handleGroupAutocompleteChange}
                         placeholder="Group Name..."
              />
            )}
          />
          <div className={classes.addContainer} >
            <Button
              className={classes.btnStyle}
              variant="contained"
              onClick={handleGroupAdd}
            >
              ADD
            </Button>
          </div>
        </div>
      </div>

      <div>
        <table className={classes.table}>
          <thead>
          <tr>
            <th className={classes.tableStyle} key="table-header-type">Mandatory Type</th>
            <th className={classes.tableStyle} key="table-header-users">Users & Groups</th>
          </tr>
          </thead>
          <tbody>
          {types.map(type => getReviewerRow(type) )}
          </tbody>
        </table>
      </div>

    </main>
  );
}
